export default __webpack_public_path__ + "static/media/84.f45c08db.jpg";